export const menuItemsMock = [
    {
        code: 'SMARTLY_HOME',
        title: 'Home',
        path: '/home',
        icon: 'home',
        active: true,
    },
    {
        code: 'SMARTLY_CALENDAR',
        title: 'Calendar',
        path: '/calendar',
        icon: 'calendar',
    },
    {
        code: 'SMARTLY_ACTIVITY',
        title: 'Activity',
        path: '/activity',
        icon: 'check-circle',
    },
    {
        code: 'SMARTLY_NOTIFICATIONS',
        title: 'Notifications',
        path: '/notifications',
        icon: 'bell',
    },
    {
        code: 'SMARTLY_RESOURCES',
        title: 'Resources',
        path: '/resources',
        icon: 'folders',
    },
    {
        code: 'SMARTLY_GALLERY',
        title: 'Gallery',
        path: '/gallery',
        icon: 'camera',
    },
    {
        code: 'SMARTLY_MENU',
        title: 'Menu',
        path: '/menu',
        icon: 'menu',
        children: [
            {
                code: 'SMARTLY_FORUM',
                title: 'Forum',
                path: '/menu/forum',
                icon: 'comments',
                portal_id: '3',
            },
            {
                code: 'SMARTLY_LINKS',
                title: 'Quick Links',
                path: '/menu/quick-links',
                icon: 'link',
                portal_id: '3',
            },
            {
                code: 'SMARTLY_STORE_LIST',
                title: 'Store List',
                path: '/menu/store-list',
                icon: 'store',
                portal_id: '3',
            },
            // {
            //     code: 'SMARTLY_GRSD',
            //     title: 'GRSD',
            //     path: '/menu/grsd',
            //     icon: 'chart-pie',
            //     portal_id: '3',
            // },
            {
                code: 'SMARTLY_REPORTS',
                title: 'Reports',
                path: '/reporting',
                icon: 'chart-line',
                portal_id: '3',
            },
            {
                code: 'SMARTLY_PROFILE_MGMT',
                title: 'Profile Management',
                path: '/profile-mgmt',
                icon: 'user',
                portal_id: '3',
            },
            {
                code: 'AFTERSALES',
                title: 'Aftersales',
                path: '/aftersales',
                icon: 'aftersales',
                portal_id: '3',
            },
            {
                code: 'OLD_STORE360',
                title: 'Go to Old',
                path: 'https://store360-dev.luxottica.com/',
                icon: 'switch',
                portal_id: '3',
            },
        ],
    },
]

export enum MenuItemCode {
    OLD_STORE360 = 'OLD_STORE360',
    SMARTLY_PROFILE_MGMT = 'SMARTLY_PROFILE_MGMT',
    SMARTLY_REPORT = 'SMARTLY_REPORTS',
    SMARTLY_GRSD = 'SMARTLY_GRSD'
}
